import { cx } from "@emotion/css";
import MuiStep from "@mui/material/Step";
import type { StepIconProps } from "@mui/material/StepIcon";
import MuiStepLabel from "@mui/material/StepLabel";
import MuiStepper from "@mui/material/Stepper";
import { Check } from "lucide-react";

const StepIcon = ({ active, completed, icon }: StepIconProps) => (
	<span
		className={cx(
			"stepper-step-circle",
			(active || completed) && "stepper-step-circle--active",
		)}
	>
		{completed ? <Check className="icon-super-small" /> : icon}
	</span>
);

interface StepperProps {
	steps: string[];
	activeStep: number;
	className?: string;
}

export const Stepper = ({ steps, activeStep, className }: StepperProps) => (
	<MuiStepper activeStep={activeStep} className={cx("stepper", className)}>
		{steps.map((label) => (
			<MuiStep key={label}>
				<MuiStepLabel
					slots={{
						stepIcon: StepIcon,
					}}
				>
					{label}
				</MuiStepLabel>
			</MuiStep>
		))}
	</MuiStepper>
);
